module.exports = __webpack_public_path__ + "static/media/building-04.bdb88aad.png";